import React from 'react';
import { inZone } from '../utils/companyDate';
import { useCompanyTimezone } from '../context/AuthContext';

// The "SMS" marker beside Do Not Serve on the Customers list. Shown for a
// customer who has opted in to text messages, and as a muted "SMS off" for one
// who opted out; nothing for no consent. A property shows its customer's
// state, which the server reads through to the root row. When and how are on
// hover.
const SOURCE_LABELS = {
  intake_form: 'signup form',
  owner_attested: 'recorded by the business',
  keyword_start: 'texted START',
  portal: 'customer portal',
};

export const smsSourceLabel = (source) => SOURCE_LABELS[source] || source || 'unknown';

const fmt = (iso, timezone) => (iso ? new Date(iso).toLocaleDateString('en-US', inZone(timezone, { month: 'short', day: 'numeric', year: 'numeric' })) : '');

function SmsConsentBadge({ row, inherited = false, style }) {
  const timezone = useCompanyTimezone();
  if (!row || (row.sms_consent !== 'opted_in' && row.sms_consent !== 'opted_out')) return null;
  const optedIn = row.sms_consent === 'opted_in';
  const title = [
    optedIn
      ? `Agreed to texts ${fmt(row.sms_consent_at, timezone)} (${smsSourceLabel(row.sms_consent_source)}).`
      : `Opted out of texts ${fmt(row.sms_opted_out_at, timezone)}.`,
    inherited ? 'Inherited from the parent customer.' : null,
  ].filter(Boolean).join(' ');

  return (
    <span
      className="sms-consent-badge"
      title={title}
      style={{
        display: 'inline-block',
        marginLeft: '6px',
        padding: '1px 7px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: 600,
        lineHeight: '16px',
        color: optedIn ? '#fff' : '#555',
        backgroundColor: optedIn ? '#2e7d32' : '#e0e0e0',
        textDecoration: optedIn ? 'none' : 'line-through',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      SMS
    </span>
  );
}

export default SmsConsentBadge;
